<template>
    <div
        class="material-option__color-select"
        tabindex="0"
        @focusout="isOpen = false"
    >
        <!--div class="dropdown is-right" :class="{'is-active': isOpen}">
      <div class="dropdown-trigger" v-if="printMode.colors.length > 1"
           @click="isAnyColorPrintable ? isOpen = !isOpen : isOpen = false"
           :style="{'background': value.hex}">
        <div class="dropdown-icon">
          <img src="@/assets/img/chevron-right.svg" style="transform: rotate(90deg);" alt="chevron">
        </div>
      </div>
      <div class="dropdown-menu">
        <div class="dropdown-content" @click.stop="isOpen = false">
          <div class="dropdown-item item--color"
               v-for="(color, index) in printMode.colors"
               :class="{'is-disabled': !isColorAvailable(color._id)}"
               v-bind:key="'dropdown_' + color._id"
               @click="changeColor(index)">
                        <span class="item--color__preview"
                              :style="{'background': color.hex}"></span>
            <span class="item--color__label">{{ color.name }}</span>
            <keep-alive>
              <PrintModePrice :print-mode="printMode" :current-color="color"></PrintModePrice>
            </keep-alive>
          </div>
        </div>
      </div>
    </div-->
        <span class="material-option__price">
            <keep-alive>
                <PrintModePrice
                    :is-loading="isLoading"
                    :print-mode="printMode"
                    :current-color="selectedColor"
                    @change="$emit('change', selectedColor)"
                ></PrintModePrice>
            </keep-alive>
        </span>
    </div>
</template>

<script>
import PrintModePrice from './PrintModePrice';
import { mapGetters } from 'vuex';

export default {
    name: 'PrintModeColorSelect',
    components: { PrintModePrice },
    data() {
        return {
            isOpen: false,
            selectedColorIndex: 0,
            rainbowGradient:
                'linear-gradient(135deg, rgba(131,58,180,1) 0%, rgba(253,29,29,1) 40%, rgba(252,176,69,1) 56%, rgba(253,231,42,1) 76%, rgba(114,253,50,1) 100%)',
        };
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        printMode: {
            type: Object,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    computed: {
        ...mapGetters(['currentCartItem']),
        selectedColor() {
            return this.printMode.colors[this.selectedColorIndex];
        },
        isAnyColorPrintable() {
            return this.printMode.colors
                .map((color) => color.pricing.printable)
                .includes(true);
        },
    },
    methods: {
        changeColor(index) {
            const color = this.printMode.colors[index];
            if (this.isColorAvailable(color._id)) {
                this.selectedColorIndex = index;
                this.$emit('change', color);
            }
        },
        isColorAvailable(id) {
            let containsSelectedFinish = false;
            if (this.currentCartItem.surfaceFinishId) {
                containsSelectedFinish = this.printMode.colors
                    .find((color) => color._id === id)
                    .surfaceFinishes.includes(
                        this.currentCartItem.surfaceFinishId
                    );
            } else {
                containsSelectedFinish =
                    this.printMode.colors.find((color) => color._id === id)
                        .surfaceFinishes.length === 0;
            }
            return containsSelectedFinish;
        },
    },
};
</script>

<style scoped></style>
